var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ski-search"},[_c('HgSkiSearch',{attrs:{"allowHotjarRecord":"","is-mobile":_vm.isMobile,"search-url":_vm.searchUrl,"destinations":_vm.traveltrexDestinations,"dates":{
      startDate: new Date(),
      relativeEndDays: 540
    }},on:{"onUpdateDestinationTerm":_vm.updateDestinationTerm,"onUpdateSearchParameters":_vm.updateSearchParameters,"onTriggerSearch":_vm.triggerSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }